/* eslint-disable */
export default {
    'checkout.back': 'Back',
    'checkout.steps.info': 'Details',
    'checkout.steps.payment': 'Payment',
    'checkout.steps.done': 'Confirmation',

    'common.close': 'Close X',

    'widget.vacancies': '{n} spots available!',
    'widget.vacanciesTooltip': 'This is the number of people who can still join this event',
    'widget.event': 'Event:',
    'widget.eventClosed': 'Private',
    'widget.scheduledBy': 'Scheduled by:',
    'widget.contact': 'Contact:',
    'widget.choosePackage': 'Choose your ticket',
    'widget.available': 'available',
    'widget.noTickets': 'No ticket types available. Please contact us to continue.',
    'widget.continue': 'CONTINUE',
    'widget.disagree': 'Is there any information here you disagree with?',
    'widget.reportProblem': 'Report a problem',
    'widget.easyCancellation': 'Easy Cancellation',
    'widget.dataSecurity': 'Data Security',
    'widget.cancelRules': 'Cancellation Policy',
    'widget.chooseDate': 'Choose a Date:',
    'widget.chooseHour': 'Choose a Time:',
    'widget.today': 'Today',
    'widget.select': 'SELECT',
    'widget.noDates': 'Unfortunately there are no dates available for online booking. Please contact us to learn more.',
    'widget.insertData': 'Enter your details:',
    'widget.freeScheduling': 'You don’t need to pay to book',
    'widget.shareInvite': 'Invite your friends by sharing this link with the booking details:',
    'widget.reserved': 'Your time slot is booked!',
    'widget.copy': 'Copy',
    'widget.reserveHour': 'Book a time',
    'widget.unavailable': 'Unavailable',
    'widget.hourStillAvailable': 'Time still available',
    'widget.reserve': 'Book',
    'widget.spots': 'spots',

    'auth.facebook': 'LOG IN WITH FACEBOOK',
    'auth.or': 'or',
    'auth.name': 'Name',
    'auth.email': 'Email',
    'auth.phone': 'Phone',
    'auth.password': 'Password',
    'auth.signupButton': 'SIGN UP',
    'auth.signinButton': 'LOG IN',
    'auth.signin': 'Log in',
    'auth.signup': 'Sign up',
    'auth.forgot': 'Forgot my password',
    'auth.send': 'Send',
    'auth.loggedIn': 'Logged in successfully',
    'auth.facebookError': 'Failed to sign in with Facebook.',
    'auth.forgotSent': 'An email with your new password has been sent!',
    'validation.requiredField': '"{field}" cannot be blank.',
    'validation.invalidField': 'Invalid "{field}".',

    'checkout.info.title': 'Details',
    'checkout.info.selectParticipant': 'Select a participant to fill in their details:',
    'checkout.info.fillParticipant': 'Fill in the participant details:',
    'checkout.info.participant': 'Participant {n}',
    'checkout.info.fullName': 'Full name*',
    'checkout.info.nameRequired': 'Name is required',
    'checkout.info.email': 'Email*',
    'checkout.info.emailInvalid': 'Invalid email',
    'checkout.info.cellPhone': 'Mobile phone*',
    'checkout.info.observation': 'Notes',
    'checkout.info.observationHint': '(E.g. special assistance, promo code, etc.)',
    'checkout.info.privacyAgree': 'I agree with the {link}',
    'checkout.info.privacyPolicy': 'Data privacy policy',
    'checkout.continue': 'Continue',
    'checkout.next': 'Next',

    'payment.title': 'Payment',
    'payment.choose': 'Choose your payment method:',
    'payment.discount.title': 'Discount',
    'payment.discount.question': 'Have a discount coupon? Apply it here:',
    'payment.discount.placeholder': 'Discount coupon',
    'payment.discount.apply': 'Apply',
    'payment.discount.remove': 'Remove',
    'payment.discount.added': 'Coupon applied successfully!',
    'payment.discount.removed': 'Coupon removed successfully!',
    'payment.discount.invalid': 'Invalid coupon!',
    'payment.confirmAndPay': 'CONFIRM AND PAY',
    'payment.reserve': 'BOOK NOW',
    'payment.redirectInfo': 'After confirming, you will be redirected to the secure {gateway} page to complete the payment and then brought back here.',
    'payment.creditCardBrazilOnly': 'Credit card payments only accept cards issued in Brazil. If your card is international, please use PayPal.',

    'phone.label': 'Phone',
    'phone.intlHint': '+1 415 555 0100',
    'validation.phoneInvalid': 'Invalid phone number',
};
